import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  HostListener,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'abb-shadow-scrollbar-container',
  standalone: true,
  template: `
    <div
      #scrollContainer
      class="h-full w-full overflow-y-auto px-4"
      [ngClass]="className()"
      (scroll)="onScroll()"
    >
      <div
        [ngClass]="{
          'absolute top-0 left-0 w-full h-3 bg-gradient-to-b from-abb-black/[0.39] to-transparent pointer-events-none':
            showTopShadow()
        }"
      ></div>
      <ng-content></ng-content>
      <div
        [ngClass]="{
          'absolute bottom-0 left-0 w-full h-3 bg-gradient-to-t from-abb-black/[0.39] to-transparent pointer-events-none':
            showBottomShadow()
        }"
      ></div>
    </div>
  `,
  styles: ``,
  imports: [CommonModule],
  host: {
    class: 'relative',
  },
})
export class ShadowScrollbarContainerComponent implements AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  className = input<string>('');
  showTopShadow = signal(false);
  showBottomShadow = signal(false);

  ngAfterViewInit() {
    this.updateShadows();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateShadows();
  }

  onScroll() {
    this.updateShadows();
  }

  updateShadows() {
    const container = this.scrollContainer.nativeElement;
    this.showTopShadow.set(container.scrollTop > 0);

    const scrollValue = container.clientHeight + container.scrollTop;
    const intType = Number.isInteger(scrollValue);
    this.showBottomShadow.set(
      intType
        ? container.scrollHeight >= scrollValue
        : container.scrollHeight > Math.round(scrollValue)
    );
  }
}
